import React, { useState, useEffect } from "react";
import { withFormik } from "formik";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import * as Yup from "yup";
import KenButton from "../../../components/KenButton";
import KenLoader from "../../../components/KenLoader/KenLoader";
import KenSnackBar from "../../../components/KenSnackbar";
import KenInputField from "../../../components/KenInputField";
import KenSelect from "../../../components/KenSelect";
import {
  getYear,
  postDetails,
  getPrograms,
  getDepartment,
} from "../../../utils/ApiService";
import KenCheckbox from "../../../components/KenCheckbox/index";
import CountryStateJson from "../../../utils/CountryStates.json";
import StateCityJson from "../../../utils/StateCity.json";
import CountryJson from "../../../utils/studentInfoCountry.json";
import Messages from "../../../json/validationErrors.json";
import countryCodes from "../../../utils/countryISDCode.json";

const messages = Messages.messages;
const useStyles = makeStyles({
  selectGrid: {
    flexGrow: 0,
    // maxWidth: "100%",
    flexBasis: "100%",
    overflowX: "hidden",
    width: 220,
  },
  declarationText: {
    fontSize: "14px",
    paddingTop: "10px",
    textAlign: "justify",
  },
  submitBtn: {
    marginBottom: 10,
  },
});

export default function FormInfo(props) {
  return (
    <div>
      <FormikHoc {...props} />
    </div>
  );
}

const InfoForm = (props) => {
  const {
    values,
    touched,
    errors,
    handleChange,
    handleSubmit,
    setFieldTouched,
    setFieldValue,
    loading,
    prog,
    setProg,
  } = props;

  const classes = useStyles();
  const options = countryCodes.codes;

  const change = (name, e) => {
    e.persist();
    handleChange(e);

    if (name === "department") {
      let programs = [];
      getPrograms(e.target.value).then((res) => {
        res.forEach((el) => {
          programs.push({
            label: el.Name,
            value: el.Name,
          });
        });
        console.log(programs);
        setProg(programs);
      });
    }

    if (name === "country") {
      setFieldValue("state", "");
    }

    if (name === "state") {
      setFieldValue("city", "");
    }
    setFieldTouched(name, true, false);
  };

  const [year, setYear] = useState([]);
  const [department, setDepartment] = useState([]);
  const getCities = (value) => {
    // console.log("state for city", value);
    const cityStates = StateCityJson.states.find(
      (state) => state.value === value
    );
    let districts = cityStates?.districts || [];
    let cities = [];
    districts.forEach((district) => {
      cities.push({
        label: district,
        value: district,
      });
    });
    // console.log("cities", cities);
    return cities;
  };
  // const [countrycode, setCountryCode] = useState([]);
  // React.useEffect(() => {
  //   setCountryCode(
  //     countryCodes.codes.map((el) => {
  //       return { label: el.name, value: el.id };
  //     })
  //   );
  // }, []);
  const getStates = (value) => {
    const statesObject = CountryStateJson.countries.find(
      (country) => country.country === value
    );
    let statesArray = statesObject?.states || [];
    let statesOfValue = [
      {
        label: "State",
        value: "State",
      },
    ];
    statesArray.map((state) => {
      statesOfValue.push({
        label: state,
        value: state,
      });
    });
    return statesOfValue;
  };

  useEffect(() => {
    getYear().then((res) => {
      let yearRes = [];
      res.map((el) => {
        yearRes.push({ label: el.year, value: el.year });
      });
      setYear(yearRes);
    });

    getDepartment().then((res) => {
      let departmentRes = [];
      console.log(res);
      res.map((el) => {
        departmentRes.push({ label: el.Name, value: el.Id });
      });
      setDepartment(departmentRes);
    });
  }, []);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbar(false);
  };

  values.handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  return (
    <React.Fragment>
      <form style={{ position: "relative" }}>
        {loading && <KenLoader size={24} />}
        <div style={{ margin: "0px 0px 0px 0px" }}>
          <Grid container style={{ padding: "12px 24px" }}>
            <Grid container spacing={2}>
              <Grid item sm={6} xs={12}>
                <KenInputField
                  required={true}
                  onChange={change.bind(null, "firstName")}
                  name="firstName"
                  value={values.firstName}
                  placeholder="Enter FirstName"
                  label="First Name"
                  errors={errors.firstName}
                  touched={touched.firstName}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <KenInputField
                  required={true}
                  onChange={change.bind(null, "lastName")}
                  name="lastName"
                  placeholder="Enter LastName"
                  value={values.lastName}
                  label="Last Name"
                  errors={errors.lastName}
                  touched={touched.lastName}
                />
              </Grid>
              <Grid item sm={12} xs={12}>
                <KenInputField
                  required={true}
                  onChange={change.bind(null, "email")}
                  name="email"
                  value={values.email}
                  label="Email"
                  placeholder="Enter Email"
                  errors={errors.email}
                  touched={touched.email}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <KenInputField
                  required={true}
                  label="Mobile Number"
                  name="mobile"
                  placeholder="Enter Mobile number"
                  value={values.mobile}
                  onChange={change.bind(null, "mobile")}
                  startAdornment
                  errors={errors.mobile}
                  touched={touched.mobile}
                  startAdornmentIcon={
                    <div style={{ marginTop: "-4px", marginBottom: "0px" }}>
                      <KenSelect
                        optionalLabel={false}
                        options={options}
                        value={values.countrycode}
                        name="countrycode"
                        onChange={change.bind(null, "countrycode")}
                        defaultValue={() => {
                          setFieldValue("countrycode", "91");
                          return "+91";
                        }}
                      />
                    </div>
                  }
                />
              </Grid>
              {/* <Grid item sm={6} xs={12}>
                <KenInputField
                  required={true}
                  label="Child's Name"
                  placeholder='Enter Fullname'
                  name='childsName'
                  value={values.childsName}
                  onChange={change.bind(null, 'childsName')}
                  errors={errors.childsName}
                  touched={touched.childsName}
                />
              </Grid> */}
              {/* <Grid item sm={6} xs={12}>
                <KenInputField
                  required={true}
                  label="Age (in years)"
                  placeholder='Enter age in years'
                  name='childsAge'
                  value={values.childsAge}
                  onChange={change.bind(null, 'childsAge')}
                  errors={errors.childsAge}
                  touched={touched.childsAge}
                />
              </Grid> */}
              <Grid item sm={6} xs={12} className={classes.selectGrid}>
                <KenSelect
                  required={true}
                  name="country"
                  value={values.country}
                  label="Country"
                  placeholder="Select"
                  options={CountryJson.countries}
                  defaultValue={() => {
                    setFieldValue("country", "India");
                    return "India";
                  }}
                  errors={errors.country}
                  touched={touched.country}
                  onChange={change.bind(null, "country")}
                />
              </Grid>
              {/* <Grid item sm={6} xs={12} className={classes.selectGrid}>
                <KenInputField
                  required={true}
                  name='postalCode'
                  value={values.postalCode}
                  label='Pincode of your area'
                  placeholder='Enter Pincode'
                  errors={errors.postalCode}
                  touched={touched.postalCode}
                  onChange={change.bind(null, 'postalCode')}
                />
              </Grid> */}
              <Grid item sm={6} xs={12} className={classes.selectGrid}>
                <KenSelect
                  required={true}
                  name="state"
                  value={values.state}
                  label="State"
                  placeholder="Select"
                  // options={stateCity.states}
                  options={getStates(values.country)}
                  errors={errors.state}
                  touched={touched.state}
                  onChange={change.bind(null, "state")}
                />
              </Grid>
              <Grid item sm={6} xs={12} className={classes.selectGrid}>
                {values?.country?.toUpperCase() === "INDIA" ? (
                  <KenSelect
                    required={true}
                    name="city"
                    value={values.city}
                    label="City"
                    options={getCities(values.state)}
                    errors={errors.city}
                    touched={touched.city}
                    onChange={change.bind(null, "city")}
                  />
                ) : (
                  <KenInputField
                    required={true}
                    name="city"
                    value={values.city}
                    label="City"
                    errors={errors.city}
                    touched={touched.city}
                    onChange={change.bind(null, "city")}
                  />
                )}
              </Grid>

              {/* <Grid item sm={12} xs={12} className={classes.selectGrid}>
                <KenSelect
                  required={true}
                  name="department"
                  value={values.department}
                  label="Faculty"
                  placeholder="Select"
                  options={department}
                  errors={errors.department}
                  touched={touched.department}
                  onChange={change.bind(null, "department")}
                />
              </Grid> */}
              <Grid item sm={12} xs={12} className={classes.selectGrid}>
                <KenSelect
                  required={true}
                  name="academicPrograms"
                  value={values.academicPrograms}
                  label="Courses"
                  placeholder="Select"
                  options={prog}
                  errors={errors.academicPrograms}
                  touched={touched.academicPrograms}
                  onChange={change.bind(null, "academicPrograms")}
                />
              </Grid>

              <Grid item xs={12} style={{ display: "flex" }}>
                <KenCheckbox
                  name="declaration"
                  value={values.declaration}
                  onChange={(event) => {
                    setFieldValue("declaration", event.target.checked);
                  }}
                ></KenCheckbox>
                <Typography className={classes.declarationText}>
                  I agree to receive information from JD Institute of Fashion
                  Technology , Bangalore.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <KenButton
            className={classes.submitBtn}
            variant="primary"
            onClick={() => {
              handleSubmit();
            }}
          >
            SUBMIT
          </KenButton>
        </div>
      </form>
      <KenSnackBar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={5000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
    </React.Fragment>
  );
};

const FormikHoc = (props) => {
  let firstName;
  let lastName;
  let email;
  let mobile;
  let country;
  let countrycode;
  // let state;
  // let city;
  let postalCode;
  // let academicPrograms;
  let year;
  let handleSnackbarOpen;
  // let department;
  let childsAge;
  let childsName;

  const [toggle, setToggle] = useState(true);

  const stringRegExp = /^[a-zA-Z ]*$/;
  const phoneRegExp = /^(\+\d{1,3}[- ]?)?\d{10}$/;
  const pincodeExp = /^[0-9]{6,6}$/;
  const fullNameExp = /^(\w+\s+\w+)$/;
  const [program, setProgram] = useState();
  const [prog, setProg] = useState([
    {
      label: "Please select a Course",
      value: "Please select a Department",
    },
  ]);
  React.useEffect(() => {
    getPrograms().then((res) => {
      if (res) {
        //         res.push({
        //           Name: "academicPrograms",
        //         });
        setProgram(res);
        setProg(
          res.map((el) => {
            return {
              label: el.Name,
              value: el.Name,
            };
          })
        );
      }
    });
  }, []);

  const FormikForm = withFormik({
    mapPropsToValues: () => ({
      firstName: firstName,
      lastName: lastName,
      email: email,
      countrycode: countrycode,
      mobile: mobile,
      country: country,
      // state: state,
      // city: city,
      childsAge,
      // childsName,
      postalCode: postalCode,
      // academicPrograms: academicPrograms,
      year: year,
      // department: department,
      handleSnackbarOpen: handleSnackbarOpen,
      declaration: true,
      toggle: toggle,
      setToggle: setToggle,
    }),

    validationSchema: () =>
      Yup.object().shape({
        firstName: Yup.string()
          .matches(stringRegExp, messages?.name?.match)
          .max(15, messages?.name?.max)
          .required(messages?.required),
        lastName: Yup.string()
          .matches(stringRegExp, messages?.name?.match)
          .max(15, messages?.name?.max)
          .required(messages?.required),
        email: Yup.string().email(messages?.email).required(messages?.required),
        mobile: Yup.string()
          .matches(phoneRegExp, messages?.mobile)
          .required(messages?.required),
        country: Yup.string().nullable().required(messages?.required),
        // state: Yup.string().nullable().required(messages?.required),
        // city: Yup.string().nullable().required(messages?.required),
        // department: Yup.string().nullable().required(messages?.required),
        // postalCode: Yup.string()
        //   .matches(pincodeExp, messages?.pinCode)
        //   .nullable()
        //   .required(messages?.required),
        // childsAge: Yup.number()
        //   .required(messages?.required)
        //   .typeError(messages?.type)
        //   .min(`${18}`, messages.age?.range),
        //         childsName: Yup.string()
        //           .required(`${messages?.required}`),
        //.matches(fullNameExp, messages?.fullName),
        academicPrograms: Yup.string()
          .test(
            "academic-Programs",
            messages?.required,
            (val) => val !== messages?.dept
          )
          .required(messages?.required),
      }),

    handleSubmit: (values, { resetForm }) => {
      console.log("declaration", values.declaration);
      if (values.declaration) {
        let payload = {
          Email: values.email,
          Phone: `${values.countrycode}${values.mobile}`,
          First_Name: values.firstName,
          Last_Name: values.lastName,
          child_name: values.firstName,
          child_age: "20",
          Applying_To: values.academicPrograms,
          Batch_Year: "2021",
          leadsource: "Web",
          City: values.city,
          State: values.state,
          Country: values.country,
          // Postal_Code: values.postalCode,
          Course_Type__c: "kle",
          Location__c: values.state,
        };
        console.log("payload", payload);
        postDetails(payload)
          .then((res) => {
            console.log("result", res.createResponse.result.errors);
            if (res.createResponse.result.errors) {
              if (
                res.createResponse.result.errors.statusCode ===
                "DUPLICATES_DETECTED"
              ) {
                values.handleSnackbarOpen(
                  "warning",
                  "Invalid email or mobile number"
                );
              } else {
                values.handleSnackbarOpen("warning", "Something went wrong.");
              }
            } else {
              props.setShowForm(false);
            }
          })
          .catch((err) => {
            console.log("error", err);
            values.handleSnackbarOpen("warning", "Something went wrong.");
          });
      } else {
        values.handleSnackbarOpen("error", "Please accept the declaration");
      }
    },
    displayName: "InfoForm",
  })(InfoForm);

  return <FormikForm {...props} prog={prog} setProg={setProg} />;
};
